module.exports = __webpack_public_path__ + "img/type10070.b7e94281.png";